// Intercepts ATC button clicks before Kalles' handlers run (capture phase).
// Bypasses the Exemptify fetch interference that caused the native handler to hang.
(function () {
  document.addEventListener('click', function (e) {
    var button = e.target.closest('[type="submit"][name="add"]');
    if (!button) return;

    var form = button.closest('.hdt-main-product-form');
    if (!form) {
      var formId = button.getAttribute('form');
      if (formId) form = document.getElementById(formId);
      if (!form) form = button.closest('form');
      if (!form || !form.classList.contains('hdt-main-product-form')) return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    if (button.getAttribute('disabled') === 'true' || button.disabled) return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    button.setAttribute('disabled', 'true');
    button.setAttribute('aria-busy', 'true');

    // Cart drawer section ID — 'cart-drawer' is the key in system-group.json
    var drawerEl = document.querySelector('hdt-cart-drawer');
    var sectionId = (drawerEl && drawerEl.getAttribute('section-id')) || 'cart-drawer';

    var formData = new FormData(form);
    formData.set('sections', sectionId);

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');

        if (data.status) {
          console.error('[cart-fix] ATC error:', data.description || data.message);
          return;
        }

        // Dispatch Kalles cart:update so CartDrawer re-renders and opens
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: form.id || '',
            cartData: data,
            actionAfterATC: '',
            source: 'product-form-component',
            data: { sections: data.sections || {} }
          }
        }));
      })
      .catch(function (err) {
        console.error('[cart-fix] fetch error:', err);
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
      });
  }, true);
})();
